<template>
  <eagle-list
    @updatePopupSelectData="updatePopupSelectData"
    :list-key="listKey"
  ></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './fileListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'file-list-selector',
    meta: {},
  }),
  methods: {
    updatePopupSelectData(data) {
      this.$emit('updateData', data)
    },
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.fileApi.index(params)
    },
    getListConfig() {
      return listConfig
    },
  },
  computed: {
    fileBaseUrl() {
      return this.$store.getters['base/fileBaseUrl']
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
